var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 33,
  height: 23,
  viewBox: "0 0 33 23"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(0 .125)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#9B9B9B",
  fillOpacity: .771,
  d: "M25.34 11a1 1 0 0 0-1.001-1H11.414l2.873-2.88a.999.999 0 0 0 .002-1.415 1.005 1.005 0 0 0-1.417.007l-4.576 4.576a1.01 1.01 0 0 0 0 1.424l4.576 4.576a1 1 0 0 0 1.417.007c.39-.39.387-1.024-.002-1.414L11.414 12H24.34a.998.998 0 0 0 1.001-1z"
}), /*#__PURE__*/React.createElement("rect", {
  width: 31,
  height: 21,
  x: .962,
  y: .5,
  fillRule: "nonzero",
  stroke: "#B2B2B2",
  rx: 2
}))));
export default __webpack_public_path__ + "teg/media/back-bordered.3e43fc70.svg";
export { SvgComponent as ReactComponent };